import { ColoredBadge as UiColoredBadge, styled } from "@l2r-front/l2r-ui"

type StyledColoredBadgeProps = {
    borderColor: string
}

export const ColoredBadge = styled(UiColoredBadge, { shouldForwardProp: prop => prop !== "borderColor" })<StyledColoredBadgeProps>(({ theme, borderColor }) => ({
    border: `1px solid ${borderColor}`,
    padding: theme.spacing(1.5),
    width: 50,
}))